import { useRef } from "react";
// eslint-disable-next-line no-unused-vars
import { useInView, motion } from "framer-motion";

const ValuesPage = ({ id }) => {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const isInView1 = useInView(ref1, { once: true, margin: "-100px" });
  const isInView2 = useInView(ref2, { once: true, margin: "-100px" });

  return (
    <div>
      <section
        id={id}
        className="h-full lg:h-screen flex flex-col justify-center items-center gap-3 lg:gap-14"
      >
        <p className="text-gray-800 py-5 text-lg xs:text-2xl md:text-3xl font-semibold">
          Culture of Innovation and Growth
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-4 p-3 lg:p-0 md:w-3/5 lg:w-full">
          <div className="shadow-md grid grid-rows-2 p-1 lg:p-3 bg-midnight">
            <div ref={ref1} className="p-2 flex flex-col gap-2 lg:gap-5">
              <p className="text-gray-200 font-medium lg:font-semibold text-justify text-2xl pt-5">
                Continuous Learning
              </p>
              <p className="text-gray-200 text-md text-wrap">
                We adapt, evolve, and stay ahead by fostering curiosity,
                innovation, and continuous skill development.
              </p>
            </div>
            <div className="flex justify-end items-center lg:items-end p-3">
              <motion.img
                src="/values-img1.svg"
                alt="Values image 1"
                className="w-20 xs:w-25 bg-gray-200 rounded-full p-1"
                initial={{ opacity: 0, y: 80 }}
                animate={
                  isInView1 ? { opacity: 1, y: 0 } : { opacity: 0, y: 200 }
                }
                transition={{ duration: 0.8, ease: "linear" }}
              />
            </div>
          </div>
          <div className="shadow-md grid grid-rows-2 lg:p-3 bg-gray-200">
            <div
              className="flex justify-start lg:justify-end items-center lg:items-start p-3"
            >
              <motion.img
                src="/values-img2.svg"
                alt="Values 2 Icon"
                className="w-20 xs:w-25 bg-midnight rounded-full p-1"
                initial={{ opacity: 0, y: -80 }}
                animate={
                  isInView1 ? { opacity: 1, y: 0 } : { opacity: 0, y: -80 }
                }
                transition={{ duration: 0.8, ease: "linear" }}
              />
            </div>
            <div className="p-2 flex flex-col gap-2">
              <p className="text-black font-medium lg:font-semibold text-justify text-2xl pb-2 lg:pb-5">
                Teamwork
              </p>
              <p className="text-gray text-md text-wrap pb-3 lg:pb-0">
                Collaboration and diverse ideas drive our success, helping us
                create impactful solutions and reach shared goals.
              </p>
            </div>
          </div>
          <div className="shadow-md grid grid-rows-2 p-1 lg:p-3 bg-midnight">
            <div ref={ref2} className="p-2 flex flex-col gap-2 lg:gap-5">
              <p className="text-gray-200 font-medium lg:font-semibold text-justify text-2xl pt-5">
                Resilience and Passion
              </p>
              <p className="text-gray-200 text-md text-wrap">
                With determination and a problem-solving mindset, we overcome
                obstacles and push forward with purpose.
              </p>
            </div>
            <div className="flex justify-end items-center lg:items-end p-3">
              <motion.img
                src="/values-img3.svg"
                alt="Values 3 Icon"
                className="w-20 xs:w-25 bg-gray-200 rounded-full p-1"
                initial={{ opacity: 0, y: 80 }}
                animate={
                  isInView2 ? { opacity: 1, y: 0 } : { opacity: 0, y: 200 }
                }
                transition={{ duration: 0.8, ease: "linear" }}
              />
            </div>
          </div>
          <div className="shadow-md grid grid-rows-2 lg:p-3 bg-gray-200">
            <div className="flex justify-start lg:justify-end items-center lg:items-start p-3">
              <motion.img
                src="/values-img4.svg"
                alt="Values 4 Icon"
                className="w-20 xs:w-25 bg-midnight rounded-full p-1"
                initial={{ opacity: 0, y: -80 }}
                animate={
                  isInView2 ? { opacity: 1, y: 0 } : { opacity: 0, y: -80 }
                }
                transition={{ duration: 0.8, ease: "linear" }}
              />
            </div>
            <div className="p-2 flex flex-col gap-2">
              <p className="text-black font-medium lg:font-semibold text-justify text-2xl pb-2 lg:pb-5">
                Positive Impact
              </p>
              <p className="text-gray text-md text-wrap pb-3 lg:pb-0">
                We strive to develop solutions that benefit both businesses and
                society, shaping a smarter and more sustainable future.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ValuesPage;
